<app-navbar title="Permissões" />

<div class="container m-auto py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <app-card>
    <app-card-header title="Permissões" />
    <app-table-permissions
      [loading]="loading()"
      (edit)="editRole($event)"
    />
  </app-card>
</div>

<p-dialog
  [(visible)]="permissionDialog"
  [maximizable]="false"
  [modal]="true"
  [style]="{ width: '52rem' }"
  [closable]="true"
>
  <ng-template #header>
    <div class="w-full flex-col items-center justify-center">
      <h1 class="text-2xl text-zinc-900 font-bold">Editar Permissão</h1>
      <h1 class="text-lg text-zinc-600">{{ permissionName }}</h1>
    </div>
  </ng-template>

  <div class="grid grid-cols-2 gap-4">
    <div class="col-span-2 text-zinc-900">
      Permissões
    </div>
    @for (role of roles; track $index) {
      <div class="flex items-center justify-start gap-2 text-zinc-900 font-semibold">
        <p-toggleswitch [formControl]="getRoleControl(role.label)" (onChange)="onRoleChange(role.label, $event)" /> {{ role.label }}
      </div>
    }
  </div>

  <ng-template #footer>
    <p-button label="Cancelar" [text]="true" severity="secondary" (click)="closeDialog(); $event.stopPropagation()" />
    <p-button label="Salvar" (click)="submitDialog()" />
  </ng-template>
</p-dialog>
